export default __webpack_public_path__ + "static/media/composition-graphic.4840ed69.png";